<template>
  <v-container fluid py-0 px-0 id="order-add-edit">
    <u-i-toolbar-admin :title="titlePage" :icon="icon">
      <template v-slot:end-content>
        <v-flex xs12 text-xs-right>
          <v-btn
            color="info"
            class="text-none"
            round
            :fab="$vuetify.breakpoint.smAndDown"
            :small="$vuetify.breakpoint.smAndDown"
            @click="onAdd"
          >
            <v-icon
              color="white"
              :class="$vuetify.breakpoint.mdAndUp ? 'v-icon--left' : 'v-icon--center d-flex'"
              class="mr-1"
              dark small
            >fa-solid fa-lg fa-add
            </v-icon>
            <span v-if="$vuetify.breakpoint.mdAndUp">Add Bags</span>
          </v-btn>
        </v-flex>
      </template>
    </u-i-toolbar-admin>
    <v-layout align-center py-3 fill-height>
      <v-flex xs12>
        <v-layout align-top py-0>
          <v-flex xs12 sm12 md8 py-0 px-2>
            <v-data-table
              :headers="headers"
              :items="bags"
              :hide-actions="true"
              class="elevation-2"
            >
              <template v-slot:items="props">
                <td class="text-xs-center">#{{ props.item.id }}</td>
                <td class="text-xs-center">{{ props.item.name }}</td>
                <td class="text-xs-center">{{ props.item.created }}</td>
                <td class="text-xs-center">{{ props.item.weight }}</td>
                <td
                  class="text-xs-center"
                  style="width: 56px"
                >
                  <v-checkbox
                    v-model="formTotal.ids"
                    :value="props.item.id"
                    flat
                    style="height: 24px;"
                    class="checkbox-ids ma-0"
                    color="info"
                  />
                </td>
              </template>
            </v-data-table>
          </v-flex>
          <v-flex xs6 md4 py-0 px-2>
            <v-data-table
              :headers="totalHeaders"
              :items="[formTotal]"
              :hide-actions="true"
              class="elevation-2"
            >
              <template v-slot:items="props">
                <td class="text-xs-center">{{ props.item.ids.length }}</td>
                <td class="text-xs-center">{{ bags.length }}</td>
                <td class="text-xs-center">{{ props.item.selectedKg }}</td>
                <td class="text-xs-center">{{ bagsTotalKg }}</td>
              </template>
            </v-data-table>
            <v-btn @click="onToggleSelect" black block color="primary" :disabled="!bags.length">
              {{ hasSelectAll ? 'Deselect' : 'Select' }} all bags
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout row wrap py-3>
          <v-flex xs12 sm6 md4 lg2>
            <v-btn @click="goToList" block black>
              Cancel
            </v-btn>
          </v-flex>
          <v-flex xs12 sm6 md4 lg2 pl-2>
            <v-btn @click="saveEdited" black block color="primary" :disabled="!bags.length">
              Save
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import UIToolbarAdmin from '@/components/UI/ToolbarAdmin';
import ReportsFlightsService from '@/services/Admin/ReportsFlights';

export default {
  name: 'ConsolidatedInvoice',
  props: {
    id: {
      required: false,
      type: [String, Number],
      default: 0,
    },
  },
  components: {
    UIToolbarAdmin
  },
  metaInfo() {
    const titleTemplate = `%s - Admin | ${this.titlePage}`
    return {titleTemplate}
  },
  data: () => ({
    formData: {},
    formTotal: {
      ids: [],
      selectedKg: 0,
    },
    isForm: true,
    headers: [
      {
        text: 'ID',
        value: 'id',
        align: 'center',
        sortable: false,
        class: 'font-weight-bold grey darken-2 white--text'
      },
      {
        text: 'Name',
        value: 'name',
        align: 'center',
        sortable: false,
        class: 'font-weight-bold grey darken-2 white--text'
      },
      {
        text: 'Created',
        value: 'created',
        align: 'center',
        sortable: false,
        class: 'font-weight-bold grey darken-2 white--text',
      },
      {
        text: 'Weight kg',
        value: 'weight',
        align: 'center',
        sortable: false,
        class: 'font-weight-bold grey darken-2 white--text',
      },
      {
        align: 'center',
        sortable: false,
        class: 'font-weight-bold grey darken-2 white--text',
      }
    ],
    totalHeaders: [
      {
        text: 'Selected #',
        value: 'id',
        align: 'center',
        sortable: false,
        class: 'font-weight-bold grey darken-2 white--text'
      },
      {
        text: 'Total #',
        value: 'name',
        align: 'center',
        sortable: false,
        class: 'font-weight-bold grey darken-2 white--text'
      },
      {
        text: 'Selected Kg',
        value: 'created',
        align: 'center',
        sortable: false,
        class: 'font-weight-bold grey darken-2 white--text',
      },
      {
        text: 'Total Kg',
        value: 'weight',
        align: 'center',
        sortable: false,
        class: 'font-weight-bold grey darken-2 white--text',
      },
    ]
  }),
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getData();
    },
    saveEdited() {
      this.$store.commit('setLoading', true);
      ReportsFlightsService.updateBag({flight_id: this.$route.params.id, bag_ids: this.formTotal.ids})
        .then(response => {
          if (response.data.status === this.$response.Ok) {
            this.$store.commit('setSuccess', response.data.message);
            this.goToList();
          }
        })
        .catch(error => {
          if (error.response.status === this.$response.UnprocessableEntity) {
            this.messages = this.$helpers.getProp(error, 'response.messages', {});
            this.scrollToErrorField();
          }
          this.$store.commit('setError', error.response.data.message);
        })
        .finally(() => this.$store.commit('setLoading', false));
    },
    getData() {
      this.$store.commit('setLoading', true);
      ReportsFlightsService.getBags(this.$route.params.id)
        .then(response => {
          this.formData = this.$helpers.getProp(response, 'data', {});
          this.formTotal.ids = this.$helpers.getProp(response, 'data.data', []).map(item => item.id);
        })
        .catch(error => {
          this.$store.dispatch('setError', this.$helpers.getProp(error, 'response.data.message', 'Something went wrong!'));
        })
        .finally(() => this.$store.commit('setLoading', false));
    },
    recalculateTotals() {
      this.formTotal.selectedKg = 0;
      this.bags.forEach((item) => {
        if (this.formTotal.ids.includes(item.id)) {
          this.formTotal.selectedKg += +item.weight;
        }
      })
    },
    goToList() {
      this.$router.push({name: 'AdminReportsFlights'});
    },
    onAdd() {
      this.$router.push({name: 'AdminReportsFlightsManageBagsAddBags', params: {id: this.$route.params.id}});
    },
    onToggleSelect() {
      if (this.hasSelectAll) {
        this.formTotal.ids = [];
      } else {
        this.formTotal.ids = this.bags.map(item => item.id);
      }
    }
  },
  computed: {
    hasSelectAll() {
      return this.formTotal.ids.length === this.bags.length;
    },
    bags() {
      return this.$helpers.getProp(this.formData, 'data', []);
    },
    bagsTotalKg() {
      return this.bags.reduce((total, bag) => {
        total += bag.weight;
        return total;
      }, 0);
    },
    titlePage() {
      return 'Manage bags';
    },
    icon() {
      return 'cases';
    }
  },
  watch: {
    'formTotal.ids'() {
      this.recalculateTotals();
    }
  }
}
</script>

<style lang="stylus">
.checkbox-ids {
  .v-input__slot, .v-input--selection-controls__input {
    margin: 0 !important;
  }
}
</style>
